<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<div class="container2 mobmargin" *ngIf="orderplacedflag === 0; else rezorpayorderplaced">
<div style="background-color: #dbd3be; font-family: open-sans; padding: 5px 15px; border-radius: 5px;">
    <div class="row ">
        <div class="col text-center">
            <h3 strong>Your Cart Details</h3>
        </div>

      </div>
  <div class="row">
    <div class="col-sm-4 col-lg-4 col-xl-4">
        <h3>Total Items:&nbsp;&nbsp;&nbsp;{{ totalitems }}</h3>
    </div>
    <div class="col-sm-4 col-lg-4 col-xl-4">
        <h3>Total Discount: &nbsp;&nbsp;&nbsp;{{ totaldiscount }} </h3>
    </div>
    <div class="col-sm-4 col-lg-4 col-xl-4">
        <h3>Cart Total: &nbsp;&nbsp;&nbsp;{{ payable }}</h3>
    </div>
  </div>
</div>

  <div class="row" >
        <div class="col-sm-12 col-md-12 col-lg-3 col-xl=3">
            <div class="card" style="margin-top: 2%;" >
                <div class="card-header" style="background-color: #dfc473; font-family: open-sans;">
                    <h3>Shipping Address</h3>
                </div>
                <div class="card-body" *ngIf="dataship && dataship.length>0 ; else AddShipaddress"  >
                    <p class="card-text">{{dataship[0].add_l1 +dataship[0].add_l2}}</p>
                    <p class="card-text">{{city}}</p>
                    <p class="card-text">{{state}}</p>
                    <p class="card-text">{{country}}</p>
                      <p class="card-text">
                        Pin Code: {{dataship[0].pin}}
                      </p>
                      <p class="card-text">
                          Contact No: {{dataship[0].phone}}
                        </p>
                  </div>
                  <div class="card-footer" *ngIf="dataship && dataship.length>0 ">
                        <div class="row">
                                <div class="col-12">
                                    <button class="btn btn-secondary" btn-block (click)="changeAddress()">Change address</button>
                                </div>
                            </div>
                  </div>
              </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-3 col-xl=3">
              <div class="card" style="color: #cb983f" style="margin-top: 2%"  >
                  <div class="card-header" style="background-color: #dfc473; font-family: open-sans;">
                      <h3>Billing Address</h3>
                  </div>
                  <div class="card-body" *ngIf="billship && billship.length>0; else AddBilladdress " >
                      <p class="card-text">{{billship[0].add_l1 + billship[0].add_l2}}</p>
                      <p class="card-text">{{city}}</p>
                      <p class="card-text">{{state}}</p>
                      <p class="card-text">{{country}}</p>
                        <p class="card-text">
                          Pin Code: {{billship[0].pin}}
                        </p>
                        <p class="card-text">
                            Contact No: {{billship[0].phone}}
                          </p>
                    </div>
                </div>

            </div>
            <div class="col-sm-12 col-md-12 col-lg-3 col-xl=3">
                   <div class="card" style="color: #cb983f" style="margin-top: 2%" >
                       <div class="card-header" style="background-color: #dfc473; font-family: open-sans;">
                         <h3>Payment Mode</h3>
                       </div>
                    <div class="card-body" >

                        <div style="font-size: 0.9rem !important;" class="radio" *ngFor= "let mode of payment">
                            <label>

                             <input type="radio" name="paymentmode" [(ngModel)]="payment_mode" [value] = "mode">
                              {{mode}}
                            </label>
                            </div>
                    </div>


                      </div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-3 col-xl=3">
                      <div class="card" style="color: #cb983f" style="margin-top: 2%" >
                        <div class="card-header" style="background-color: #dfc473; font-family: open-sans;">
                            <h3>Shipping Mode</h3>
                        </div>
                          <div class="card-body" style="font-size: 0.9rem !important;" >
                              <p strong style="font-style: open-sans">Shipping Mode: {{shipping_mode}}</p>
                              <span style="color: #cb983f;" *ngIf="shipping_mode === 'Rs. 99 for Orders below Rs. 500' ">Free Shipping availale for Orders over Rs. 500. Please add more products to the cart to avail the same!</span>

                          </div>

                     </div>
                </div>
 </div>

 <div class="row"  >
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl=6">
            <div class="card" style="margin-top: 2%;     padding: 10px;" >
              <h3 style="color: #9b7544">Payment Summary:</h3>
                <span style="font-size:0.9rem;">Cart Total  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp; : {{payable}}</span>
                <span style="font-size:0.9rem;">Delivery Charge&nbsp;: {{deliverycharge}} </span>
                <span style="font-size:0.9rem;">Total Payable &nbsp;&nbsp;&nbsp;&nbsp; : {{pay}} </span>
            </div>
        </div>
</div>

 <div class="row" style="margin-bottom:2%;">
   <div class="col-sm-12 col-lg-6 col-xl-6"  style="margin-top:20px;float-right ">
      <button class="btn btn-success btn-block" (click)="placeOrder()" >Place Order</button>
   </div>

 </div>
</div>
<div class="footer">
    <app-footer></app-footer>
</div>

<ng-template #AddBilladdress>
    <div>
  <button  style="margin-top:10px; padding: 10px" class="btn btn-secondary btn-block" routerLink="/store/addaddress/billing" >Add Billing address</button>
    </div>

</ng-template>

<ng-template #AddShipaddress>
  <div>
  <button  style="margin-top:10px; padding: 10px" class="btn btn-secondary btn-block" routerLink="/store/addaddress/shipping">Add Shipping address</button>
  </div>

</ng-template>
<ng-template #rezorpayorderplaced>
    <div class="container" style=" margin-top: 20px;
    height: 400px;" *ngIf="orderplacedflag === 1">
        <div class="row">
            <div class="col-12 text-center">
                <h4><p style="color:#cb983f; overflow-wrap:break-word">Your Order Has Been successfully placed </p></h4>
            </div>
            <div class="col-12 text-center" style="margin-top:15px">
               <button class="btn btn-success btn-block" (click)="goToOrder()">Manage Order</button>
            </div>
        </div>
    </div>
    <div class="container" style="    margin-top: 20px;
    height: 400px;" *ngIf="orderplacedflag === 2">
        <div class="row">
            <div class="col-12 text-center">
                <h4><p style="color:#cb983f; overflow-wrap:break-word">Your Order Has Been successfully placed
                    But payment is pending. We can process this order after completing payment</p></h4>
            </div>
        </div>
    </div>
</ng-template>
